// Fonctions utilitaires pour l'export CSV

// Export natif Microsoft Excel (.xlsx)
export const exportToCSV = async (data, filename, sheetName = 'Export') => {
  if (!data || data.length === 0) {
    return;
  }
  const { default: ExcelJS } = await import('exceljs');
  const wb = new ExcelJS.Workbook();
  wb.creator = 'JENMA Concept';
  const ws = wb.addWorksheet(sheetName, { views: [{ state: 'frozen', ySplit: 1 }] });
  const headers = Object.keys(data[0]);
  ws.columns = headers.map((h) => ({
    header: h, key: h,
    width: Math.min(60, Math.max(h.length, ...data.map((r) => String(r[h] ?? '').length)) + 4),
  }));
  data.forEach((row) => ws.addRow(row));
  const head = ws.getRow(1);
  head.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  head.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1A1A1A' } };
  head.height = 22;
  head.eachCell((c) => { c.border = { bottom: { style: 'medium', color: { argb: 'FFA68966' } } }; });
  ws.eachRow((r, i) => { if (i > 1) r.alignment = { vertical: 'top', wrapText: true }; });
  ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: headers.length } };
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename.replace(/\.csv$/i, '.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatContactForCSV = (contacts) => {
  return contacts.map(c => ({
    Date: new Date(c.timestamp).toLocaleDateString('fr-FR'),
    Heure: new Date(c.timestamp).toLocaleTimeString('fr-FR'),
    Nom: c.name,
    Email: c.email,
    'Type Projet': c.project_type,
    Message: c.message,
    Statut: c.status
  }));
};

export const formatAppointmentForCSV = (appointments) => {
  return appointments.map(a => ({
    'Date Réservation': new Date(a.timestamp).toLocaleDateString('fr-FR'),
    'Heure Réservation': new Date(a.timestamp).toLocaleTimeString('fr-FR'),
    Client: a.client_name,
    Téléphone: a.phone_number,
    'Date RDV': new Date(a.date).toLocaleDateString('fr-FR'),
    'Heure RDV': a.time,
    Statut: a.status
  }));
};
